/**
 * Element.prototype.matches
 *
 * @author Ryan Hefner <hi@ryanhefner.com>
 */

'use strict';

module.exports = (function() {
    if (Element && !Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.matchesSelector
            || Element.prototype.webkitMatchesSelector
            || Element.prototype.mozMatchesSelector
            || Element.prototype.msMatchesSelector
            || Element.prototype.oMatchesSelector;
    }
})();



//////////////////
// WEBPACK FOOTER
// ./node_modules/element.prototype.matches/index.js
// module id = 16
// module chunks = 0